const partnerRoles = ['ROLE_EXTERNAL_REQUESTER', 'ROLE_EXTERNAL_PARTNER_ADMIN']
const dispatcherReviewRoles = ['ROLE_DISPATCHER', 'ROLE_ADVANCED_DISPATCHER']

export default [
  {
    path: '/partner/requests',
    name: 'partner-order-request-list',
    meta: {
      breadcrumb: [
        { text: 'partner.menu.header' },
        { text: 'partner.order-request.list.title', active: true },
      ],
      pageTitle: 'partner.order-request.list.title',
      roles: partnerRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-order-request/partner/PartnerOrderRequestList'),
  },
  {
    path: '/partner/requests/create',
    name: 'partner-order-request-create',
    meta: {
      breadcrumb: [
        { text: 'partner.menu.header' },
        { text: 'partner.order-request.create.title', active: true },
      ],
      pageTitle: 'partner.order-request.create.title',
      roles: partnerRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-order-request/partner/PartnerOrderRequestCreate'),
  },
  {
    path: '/partner/requests/:id',
    name: 'partner-order-request-details',
    meta: {
      breadcrumb: [
        { text: 'partner.menu.header' },
        { text: 'partner.order-request.list.title', to: { name: 'partner-order-request-list' } },
        { text: 'partner.order-request.details.title', active: true },
      ],
      pageTitle: 'partner.order-request.details.title',
      roles: partnerRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-order-request/partner/PartnerOrderRequestDetails'),
  },
  {
    path: '/order-requests/review',
    name: 'dispatcher-order-request-review-list',
    meta: {
      breadcrumb: [
        { text: 'order.orders_title' },
        { text: 'dispatcher.order-request.review.list.title', active: true },
      ],
      pageTitle: 'dispatcher.order-request.review.list.title',
      roles: dispatcherReviewRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-order-request/review/DispatcherOrderRequestReviewList'),
  },
  {
    path: '/order-requests/review/:id',
    name: 'dispatcher-order-request-review-details',
    meta: {
      breadcrumb: [
        { text: 'order.orders_title' },
        { text: 'dispatcher.order-request.review.list.title', to: { name: 'dispatcher-order-request-review-list' } },
        { text: 'dispatcher.order-request.review.details.title', active: true },
      ],
      pageTitle: 'dispatcher.order-request.review.details.title',
      roles: dispatcherReviewRoles,
      organizationFeature: 'partners',
    },
    component: () => import('@/views/external-order-request/review/DispatcherOrderRequestReviewDetails'),
  },
]
